// extracted by mini-css-extract-plugin
export default {"documentsTable":"styles_documentsTable__Ta5JZ","date_cell":"styles_date_cell__CmVSi","buttonWrapper":"styles_buttonWrapper__741gF"};